module.exports = __webpack_public_path__ + "img/Fake_Video-2.e239aa37.jpg";